export default __webpack_public_path__ + "static/char-01-anr-0151deeb8ecfe2df8ca76ceca53dde43.webp";